var embed = (function (exports) {
    'use strict';

    /******************************************************************************
    Copyright (c) Microsoft Corporation.

    Permission to use, copy, modify, and/or distribute this software for any
    purpose with or without fee is hereby granted.

    THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
    REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
    AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
    INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
    LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
    OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
    PERFORMANCE OF THIS SOFTWARE.
    ***************************************************************************** */
    /* global Reflect, Promise, SuppressedError, Symbol */

    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };

    function __extends$1(d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    }

    typeof SuppressedError === "function" ? SuppressedError : function (error, suppressed, message) {
        var e = new Error(message);
        return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
    };

    var KbEvent = /** @class */ (function () {
        function KbEvent() {
            /** ordered list to hold the listeners sorted by their priority. The lower the number, the higher the priority */
            this._listeners = [];
        }
        KbEvent.prototype.add = function (callback, tag) {
            if (tag === void 0) { tag = null; }
            this._listeners.push({ callback: callback, tag: tag });
        };
        KbEvent.prototype.remove = function (callback) {
            if (typeof callback === "function") {
                for (var i = 0; i < this._listeners.length; i++) {
                    if (this._listeners[i].callback === callback) {
                        this._listeners.splice(i, 1);
                        break;
                    }
                }
            }
            else {
                this._listeners.length = 0;
            }
        };
        /*
         * removes all listeners with the given tag
         */
        KbEvent.prototype.removeByTag = function (tag) {
            for (var i = 0; i < this._listeners.length; i++) {
                if (this._listeners[i].tag === tag) {
                    this._listeners.splice(i, 1);
                }
            }
        };
        KbEvent.prototype.trigger = function (args) {
            for (var _i = 0, _a = this._listeners; _i < _a.length; _i++) {
                var l = _a[_i];
                l.callback.apply(null, [args]);
            }
        };
        return KbEvent;
    }());

    //manually import what we use from tslib so it gets tree-shaked
    var __extends = __extends$1;
    //get the url this script was loaded from
    //can replace this with document.currentScript when support for more browsers is there: https://developer.mozilla.org/en-US/docs/Web/API/document.currentScript
    var scripts = document.getElementsByTagName("script");
    var urlArr = scripts[scripts.length - 1].src.split("/");
    var kbmaxUrl = urlArr[0] + "//" + urlArr[2];
    var Embed = /** @class */ (function () {
        function Embed(args) {
            var _this = this;
            this.args = args;
            this._messageQueue = [];
            this._loading = true;
            this._callbackMap = {};
            this._correspondenceId = 1;
            this.onMessage = new KbEvent();
            this.onSubmit = new KbEvent();
            if (!args.kbmaxUrl) {
                args.kbmaxUrl = kbmaxUrl;
            }
            if (args.elementId) {
                args.elementSelector = "#" + args.elementId;
            }
            this.fillLayoutSettings();
            var elem = this.elem = document.querySelector(args.elementSelector);
            if (!elem) {
                throw new Error("no element was found with the given selector of '" + args.elementSelector + "'");
            }
            //make the main elem relative to size iframe and loading image
            if (window.getComputedStyle(elem, null)["position"] !== "absolute") {
                elem.style.position = "relative";
            }
            //if the iframe has already been loaded, then the user is just trying to regain the reference
            this._iframe = this.elem.querySelector("iframe");
            if (this._iframe) {
                this._loading = !this._iframe.hasAttribute("data-kbmax-loaded");
            }
            //we wait for the sceneLoaded event to be broadcasted by kbmax
            if (this._loading) {
                if (!this._messageHandler) {
                    this._messageHandler = function (event) {
                        var msg = event.data;
                        if (msg && msg.name) {
                            var command = msg.name.toLowerCase();
                            if (command == "configuratorloaded" || command == "sceneloaded") {
                                var sceneLoadedArgs = msg.data;
                                if (sceneLoadedArgs.requestId == args.elementSelector) { //make sure this message is for the iframe this viewer3d is tied to
                                    _this._loading = false;
                                    _this._iframe.setAttributeNode(document.createAttribute("data-kbmax-loaded"));
                                    //fade away loading image if it's there
                                    //run all messages in the queue
                                    _this._messageQueue.forEach(function (message) {
                                        _this._sendMessage(message);
                                    });
                                    if (_this._onLoaded) {
                                        _this._onLoaded();
                                    }
                                }
                            }
                            else if (command == "submit") {
                                _this.onSubmit.trigger(msg);
                            }
                            else if (command == "readytoloadconfiguredproduct") {
                                _this.readyToLoadConfiguredProduct();
                            }
                            else if (command == "loginsso") {
                                window.location.href = args.kbmaxUrl + "/ssosignin?RedirectUrl=" + window.location.href;
                            }
                            else {
                                if (msg.correspondenceId) {
                                    var callback = _this._callbackMap[parseInt(msg.correspondenceId)];
                                    if (callback)
                                        callback(msg.data);
                                }
                                else {
                                    _this.onMessage.trigger(msg);
                                }
                            }
                        }
                    };
                    window.addEventListener("message", this._messageHandler);
                }
            }
            if (!this._iframe) {
                var src = this._getIFrameSrc();
                //add the iframe to the DOM before setting it's src.  This stops it from blocking the outer page window.load event(which is bad for SEO)
                this._iframe = document.createElement("iframe");
                //now set attributes
                this._iframe.src = src;
                this._iframe.setAttributeNode(document.createAttribute("allowfullscreen"));
                this._iframe.setAttribute("allow", "xr-spatial-tracking 'self' " + this.args.kbmaxUrl + "; fullscreen *");
                this._iframe.style.width = "100%";
                this._iframe.style.height = "100%";
                this._iframe.style.position = "absolute";
                this._iframe.style.border = "none";
                this.elem.insertBefore(this._iframe, this.elem.firstChild);
                this._logo = this.elem.querySelector("a");
                if (this._logo) {
                    this._logo.href = "https://www.kbmax.com";
                    this._logo.target = "_blank";
                    this._logo.style.position = "absolute";
                    this._logo.style.right = "20px";
                    this._logo.style.bottom = "20px";
                    this._logo.style.width = "12%";
                    this._logo.style.textAlign = "right";
                    var logoImage = this._logo.querySelector("img");
                    if (logoImage) {
                        logoImage.src = args.kbmaxUrl + "/images/kbmax_logo_horizontal.png";
                        logoImage.alt = "3D Configurator by KBMax";
                        logoImage.style.maxHeight = "108px";
                        logoImage.style.maxWidth = "160px";
                        logoImage.style.height = "auto";
                        logoImage.style.width = "100%";
                    }
                }
                //setup form binding.  We do it here so it's only bound once to the event (in case there are multiple calls to initialize the same viewer)
                if (args.bindToFormSelector) {
                    var formElements = document.querySelectorAll(args.bindToFormSelector + " input, " + args.bindToFormSelector + " select, " + args.bindToFormSelector + " textarea");
                    for (var n = 0; n < formElements.length; n++) {
                        var formElement = formElements[n];
                        this.watchElementForChange(formElement);
                    }
                    //observe the form for changes, so we can process newly added inputs to the forms
                    if (window["MutationObserver"]) {
                        var observer = new MutationObserver(function (mutations) {
                            mutations.forEach(function (m) {
                                if (m.type == "childList") {
                                    for (var n = 0; n < m.addedNodes.length; n++) {
                                        var node = m.addedNodes[n];
                                        if (node instanceof HTMLInputElement || node instanceof HTMLSelectElement || node instanceof HTMLTextAreaElement) {
                                            _this.watchElementForChange(node);
                                        }
                                    }
                                }
                            });
                            if (mutations.some(function (m) { return m.type == "childList"; })) {
                                _this.setFieldsFromForm(_this.args.bindToFormSelector); //update from the form so there is immediate binding
                            }
                        });
                        //observe all the forms
                        var forms = document.querySelectorAll(args.bindToFormSelector);
                        for (var n = 0; n < forms.length; n++) {
                            var form = forms[n];
                            observer.observe(form, { childList: true, subtree: true });
                        }
                    }
                    this.setFieldsFromForm(args.bindToFormSelector);
                }
            }
        }
        Embed.prototype.watchElementForChange = function (elem) {
            var _this = this;
            elem.addEventListener("change", function () {
                _this.setFieldsFromForm(_this.args.bindToFormSelector);
            });
        };
        Embed.prototype.onLoaded = function (callback) {
            this._onLoaded = callback;
        };
        Embed.prototype._sendMessage = function (message) {
            if (this._loading) {
                this._messageQueue.push(message);
            }
            else {
                this._iframe.contentWindow.postMessage(message, "*");
            }
        };
        Embed.prototype.requireWebGL = function () {
            //if the browser doesn't support webgl, then add the loading image and bail
            if (!this.supportsWebGL()) {
                return;
            }
        };
        Embed.prototype.readyToLoadConfiguredProduct = function () {
        };
        //serializes a form to an object that can be sent to kbmax embed api
        Embed.prototype.serializeFormToObject = function (formSelector) {
            var o = {};
            var form = document.querySelector(formSelector);
            if (form) {
                var inputs = form.querySelectorAll("input, select, textarea");
                for (var i = 0; i < inputs.length; i++) {
                    var elem = inputs[i];
                    var name = elem.getAttribute("kbmax-name") || elem.getAttribute("data-kbmax-name") || elem.getAttribute("name");
                    if (name && !elem.getAttribute("disabled")) {
                        if (elem.getAttribute("type") === "checkbox") {
                            var input = elem;
                            o[name] = input.checked;
                        }
                        else if (elem.getAttribute("type") === "radio") {
                            var input = elem;
                            if (input.checked) {
                                o[name] = input.value;
                            }
                        }
                        else if (elem.tagName === "select") {
                            var select = elem;
                            if (select.multiple) {
                                o[name] = [];
                                var options = select.getElementsByTagName("option");
                                for (var j = 0; j < options.length; j++) {
                                    var option = options[j];
                                    if (option.selected) {
                                        o[name].push(option.value);
                                    }
                                }
                            }
                            else {
                                o[name] = select.value;
                            }
                        }
                        else {
                            o[name] = elem.value;
                        }
                    }
                }
            }
            return o;
        };
        Embed.prototype.supportsWebGL = function () {
            try {
                var canvas = document.createElement('canvas');
                return !!(window.WebGLRenderingContext && (canvas.getContext('webgl') || canvas.getContext('experimental-webgl')));
            }
            catch (e) {
                return false;
            }
        };
        Embed.prototype.setFieldsFromForm = function (formSelector) {
            this.setFields(this.serializeFormToObject(formSelector));
        };
        Embed.prototype.render = function () {
            var msg = {
                name: "render",
                data: undefined
            };
            this._sendMessage(msg);
        };
        Embed.prototype.snapshot = function (options, callback) {
            var correspondenceId = this._correspondenceId++;
            this._callbackMap[correspondenceId] = callback;
            this._sendMessage({
                name: "snapshot",
                data: options,
                correspondenceId: correspondenceId.toString()
            });
        };
        Embed.prototype.setFields = function (fields, callback) {
            var correspondenceId = this._correspondenceId++;
            this._callbackMap[correspondenceId] = callback;
            var msg = {
                name: "setFields",
                data: fields,
                correspondenceId: correspondenceId.toString()
            };
            this._sendMessage(msg);
        };
        Embed.prototype.getFields = function (callback) {
            var correspondenceId = this._correspondenceId++;
            this._callbackMap[correspondenceId] = callback;
            var msg = {
                name: "getFields",
                data: {},
                correspondenceId: correspondenceId.toString()
            };
            this._sendMessage(msg);
        };
        Embed.prototype.runAction = function (actionName, callback) {
            var correspondenceId = this._correspondenceId++;
            this._callbackMap[correspondenceId] = callback;
            var msg = {
                name: "runAction",
                data: actionName,
                correspondenceId: correspondenceId.toString()
            };
            this._sendMessage(msg);
        };
        Embed.prototype.runSubmitRule = function (callback) {
            var correspondenceId = this._correspondenceId++;
            this._callbackMap[correspondenceId] = callback;
            var msg = {
                name: "runsubmitrule",
                data: {},
                correspondenceId: correspondenceId.toString()
            };
            this._sendMessage(msg);
        };
        Embed.prototype.getPrice = function (callback) {
            var correspondenceId = this._correspondenceId++;
            this._callbackMap[correspondenceId] = callback;
            var msg = {
                name: "getprice",
                data: {},
                correspondenceId: correspondenceId.toString()
            };
            this._sendMessage(msg);
        };
        /**
         * collates layout settings from previous parameters to ensure backwards compatibility
         */
        Embed.prototype.fillLayoutSettings = function () {
            this.args.layoutSettings = this.args.layoutSettings || {};
            if (!this.args.layoutSettings.hasOwnProperty("Show Pages")) {
                this.args.layoutSettings["Show Pages"] = this.args.showFields;
            }
            if (!this.args.layoutSettings.hasOwnProperty("Show Header")) {
                this.args.layoutSettings["Show Header"] = this.args.showConfigHeader;
            }
        };
        /** disposes of the iframe and any handlers */
        Embed.prototype.dispose = function () {
            if (this._iframe) {
                this._iframe.remove();
                this._iframe = undefined;
            }
            if (this._logo) {
                this._logo.remove();
                this._logo = undefined;
            }
            this._messageQueue = [];
            this._loading = false;
            this._onload = undefined;
            if (this._messageHandler) {
                window.removeEventListener("message", this._messageHandler);
            }
            this._callbackMap = {};
            this.onMessage.remove();
            this.onSubmit.remove();
        };
        return Embed;
    }());
    var SceneEmbed = /** @class */ (function (_super) {
        __extends(SceneEmbed, _super);
        function SceneEmbed(args) {
            var _this = _super.call(this, args) || this;
            _this.requireWebGL();
            return _this;
        }
        SceneEmbed.prototype._getIFrameSrc = function () {
            var url = this.args.kbmaxUrl.replace(/\/+$/, "") +
                "/scenes/" + this.args.sceneId.toString() +
                "?embedded=true&requestid=" + encodeURIComponent(this.args.elementSelector) +
                //"&showfields=" + (this.args.showFields !== false) +
                "&showheader=" + (this.args.showHeader !== false) +
                //"&showconfigheader=" + (this.args.showConfigHeader !== false) +
                "&showdrawer=" + (this.args.showDrawer !== false) +
                "&showmove=" + (this.args.showMove !== false) +
                "&idtheme=" + (this.args.idTheme || "") +
                "&fields=" + (this.args.fields ? encodeURIComponent(JSON.stringify(this.args.fields)) : "") +
                "&layoutsettings=" + (this.args.layoutSettings ? encodeURIComponent(JSON.stringify(this.args.layoutSettings)) : "") +
                "&parameters=" + (this.args.parameters ? encodeURIComponent(JSON.stringify(this.args.parameters)) : "") +
                "&transparentbackground=" + (this.args.transparentBackground === true);
            return url;
        };
        return SceneEmbed;
    }(Embed));
    var ConfiguratorEmbed = /** @class */ (function (_super) {
        __extends(ConfiguratorEmbed, _super);
        function ConfiguratorEmbed(args) {
            var _this = this;
            if (args.id)
                args.configuratorId = args.id; //for backwards compatibility
            _this = _super.call(this, args) || this;
            _this.configuredProduct = args.configuredProduct;
            return _this;
        }
        ConfiguratorEmbed.prototype.readyToLoadConfiguredProduct = function () {
            var message = {
                name: "setconfiguredproduct",
                data: this.configuredProduct
            };
            this._iframe.contentWindow.postMessage(message, "*");
        };
        ConfiguratorEmbed.prototype._getIFrameSrc = function () {
            var src = this.args.kbmaxUrl.replace(/\/$/, "");
            if (this.args.configuredProductId) {
                src += "/quoteproducts/" + this.args.configuredProductId;
            }
            else {
                src += "/configurators/" + this.args.configuratorId.toString();
            }
            src += "?embedded=true&requestid=" + encodeURIComponent(this.args.elementSelector) +
                //"&showfields=" + (this.args.showFields !== false) +
                "&showheader=" + (this.args.showHeader !== false) +
                //"&showconfigheader=" + (this.args.showConfigHeader !== false) +
                "&showdrawer=" + (this.args.showDrawer !== false) +
                "&showmove=" + (this.args.showMove !== false) +
                "&currency=" + encodeURIComponent(this.args.currency || "") +
                "&idtheme=" + (this.args.idTheme || "") +
                "&fields=" + (this.args.fields ? encodeURIComponent(JSON.stringify(this.args.fields)) : "") +
                "&layoutsettings=" + (this.args.layoutSettings ? encodeURIComponent(JSON.stringify(this.args.layoutSettings)) : "") +
                "&parameters=" + (this.args.parameters ? encodeURIComponent(JSON.stringify(this.args.parameters)) : "");
            if (this.args.configuredProduct) {
                src += "&deferLoadedRule=true";
            }
            if (this.args.autoSsoLogin) {
                src += "&autoSsoLogin=true";
            }
            if (this.args.cookieToken) {
                src += "&cookieToken=" + encodeURIComponent(this.args.cookieToken);
            }
            if (this.args.kineticCompany) {
                src += "&kineticCompany=" + encodeURIComponent(this.args.kineticCompany);
            }
            if (this.args.kineticPlant) {
                src += "&kineticPlant=" + encodeURIComponent(this.args.kineticPlant);
            }
            if (this.args.kineticCustomerId) {
                src += "&kineticCustomerId=" + encodeURIComponent(this.args.kineticCustomerId);
            }
            if (this.args.kineticCustomerNumber) {
                src += "&kineticCustomerNumber=" + encodeURIComponent(this.args.kineticCustomerNumber);
            }
            if (this.args.kineticQuoteNumber) {
                src += "&kineticQuoteNumber=" + encodeURIComponent(this.args.kineticQuoteNumber);
            }
            if (this.args.kineticQuoteLine) {
                src += "&kineticQuoteLine=" + encodeURIComponent(this.args.kineticQuoteLine);
            }
            if (this.args.kineticOrderNumber) {
                src += "&kineticOrderNumber=" + encodeURIComponent(this.args.kineticOrderNumber);
            }
            if (this.args.kineticOrderLine) {
                src += "&kineticOrderLine=" + encodeURIComponent(this.args.kineticOrderLine);
            }
            if (this.args.kineticJobNumber) {
                src += "&kineticJobNumber=" + encodeURIComponent(this.args.kineticJobNumber);
            }
            if (this.args.kineticAssemblySeq) {
                src += "&kineticAssemblySeq=" + encodeURIComponent(this.args.kineticAssemblySeq);
            }
            if (this.args.kineticCallContext) {
                src += "&kineticCallContext=" + encodeURIComponent(this.args.kineticCallContext);
            }
            if (this.args.kineticUserId) {
                src += "&kineticUserId=" + encodeURIComponent(this.args.kineticUserId);
            }
            return src;
        };
        ConfiguratorEmbed.prototype.setConfiguredProduct = function (configProduct, callback) {
            var correspondenceId = this._correspondenceId++;
            this._callbackMap[correspondenceId] = callback;
            var msg = {
                name: "setConfiguredProduct",
                data: configProduct,
                correspondenceId: correspondenceId.toString()
            };
            this._sendMessage(msg);
        };
        ConfiguratorEmbed.prototype.getConfiguredProduct = function (callback) {
            var correspondenceId = this._correspondenceId++;
            this._callbackMap[correspondenceId] = callback;
            var msg = {
                name: "getConfiguredProduct",
                data: {},
                correspondenceId: correspondenceId.toString()
            };
            this._sendMessage(msg);
        };
        /**
         * saves the product to the quote and then submits the quote.
         * @param callback
         */
        ConfiguratorEmbed.prototype.saveProductAndSubmit = function (callback) {
            var correspondenceId = this._correspondenceId++;
            this._callbackMap[correspondenceId] = callback;
            var msg = {
                name: "saveProductAndSubmit",
                data: {},
                correspondenceId: correspondenceId.toString()
            };
            this._sendMessage(msg);
        };
        /**
         * saves the product to the existing quote if one exists or to a new quote if it does not
         * @param callback
         */
        ConfiguratorEmbed.prototype.saveProduct = function (callback) {
            var correspondenceId = this._correspondenceId++;
            this._callbackMap[correspondenceId] = callback;
            var msg = {
                name: "saveProduct",
                data: {},
                correspondenceId: correspondenceId.toString()
            };
            this._sendMessage(msg);
        };
        return ConfiguratorEmbed;
    }(Embed));
    //for backwards compatibility.  Can be removed in the future
    var Viewer3D = /** @class */ (function (_super) {
        __extends(Viewer3D, _super);
        function Viewer3D() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        return Viewer3D;
    }(SceneEmbed));
    var KBMaxConfigurator = /** @class */ (function (_super) {
        __extends(KBMaxConfigurator, _super);
        function KBMaxConfigurator() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        return KBMaxConfigurator;
    }(ConfiguratorEmbed));
    //if an element has the kbmax attributes, then we load a kbmax embed automatically for them
    var loadFromHtml = function () {
        var elements = document.querySelectorAll("[data-kbmax]");
        for (var i = 0; i < elements.length; i++) {
            //start a new viewer for each element that had the attribute
            var el = elements[i];
            //validation
            if (!el.id) {
                el.id = "viewer";
            }
            if (!el.hasAttribute("data-scene-id") && !el.hasAttribute("data-configurator-id")) {
                throw new Error("kbmax element must have the data-scene-id or data-configurator-id attribute");
            }
            var sceneId = Number(el.getAttribute("data-scene-id"));
            var sceneGuid = el.getAttribute("data-scene-guid");
            var configuratorId = Number(el.getAttribute("data-configurator-id"));
            var transparentBackground = (el.getAttribute("data-transparent-background") === "true");
            var showFields = !(el.getAttribute("data-show-fields") === "false");
            var showHeader = !(el.getAttribute("data-show-header") === "false");
            var showConfigHeader = !(el.getAttribute("data-show-config-header") === "false");
            var showDrawer = (el.getAttribute("data-show-drawer") === "true");
            var showMove = !(el.getAttribute("data-show-move") === "false");
            var bindToFormSelector = el.getAttribute("data-bind-to-form");
            var currency = el.getAttribute("data-currency");
            var idTheme = el.getAttribute("data-id-theme");
            var fields = el.getAttribute("data-fields");
            var layoutSettings = el.getAttribute("data-layout-settings");
            var parameters = el.getAttribute("data-parameters");
            if (configuratorId) {
                new ConfiguratorEmbed({
                    elementSelector: "#" + el.id,
                    configuratorId: configuratorId,
                    showFields: showFields,
                    showHeader: showHeader,
                    showConfigHeader: showConfigHeader,
                    showDrawer: showDrawer,
                    showMove: showMove,
                    bindToFormSelector: bindToFormSelector,
                    currency: currency,
                    idTheme: idTheme && Number(idTheme),
                    fields: JSON.parse(fields),
                    layoutSettings: JSON.parse(layoutSettings),
                    parameters: JSON.parse(parameters)
                });
            }
            else {
                new SceneEmbed({
                    elementSelector: "#" + el.id,
                    sceneId: sceneId,
                    sceneGuid: sceneGuid,
                    transparentBackground: transparentBackground,
                    showFields: showFields,
                    showHeader: showHeader,
                    showConfigHeader: showConfigHeader,
                    showDrawer: showDrawer,
                    showMove: showMove,
                    bindToFormSelector: bindToFormSelector,
                    idTheme: idTheme && Number(idTheme),
                    fields: JSON.parse(fields),
                    layoutSettings: JSON.parse(layoutSettings),
                    parameters: JSON.parse(parameters)
                });
            }
        }
    };
    //for a quick load, we try right away (hopefully the script was referenced after the html)
    loadFromHtml();
    //we check again after load in case the user had the script before the html was there
    document.addEventListener("DOMContentLoaded", function () {
        loadFromHtml();
    });

    exports.ConfiguratorEmbed = ConfiguratorEmbed;
    exports.Embed = Embed;
    exports.KBMaxConfigurator = KBMaxConfigurator;
    exports.SceneEmbed = SceneEmbed;
    exports.Viewer3D = Viewer3D;
    exports.__extends = __extends;

    Object.defineProperty(exports, '__esModule', { value: true });

    return exports;

})({});


var kbmax = embed;
//# sourceMappingURL=embed.js.map
